import styled from "@emotion/styled";
import { Box, Grid, TextField } from '@mui/material';

const CssTextFieldStyled = styled(TextField)({
    '& label.Mui-focused': {
        color: '#000',
    },
    '& .MuiInput-underline:after': {
        border: 'transparent',
    },
    '& .MuiInput-underline:before': {
        border: '1px solid #ddd',
        borderRadius: '3px',
        padding: '3px',
    },
    '& .MuiInput-root': {
        color: '#000',
        paddingLeft: '3px',
        '& fieldset': {
            borderColor: 'transparent',
        },
        '&:hover fieldset': {
            borderColor: 'transparent',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'transparent',
        }
    },
    '& label': {
        color: '#000'
    }
});

export const CssTextField = (props) => {
    return <Grid container>
        <Grid item xs={12} md={6}>
            <Box sx={{ fontWeight: 'bold', pt: 1 }}>{props.label}</Box></Grid>
        <Grid item xs={12} md={6}><CssTextFieldStyled {...props} label={null} /></Grid>

    </Grid>
}